import axios from "axios";

const API = process.env.REACT_APP_API_URL;

function compactParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
  );
}

export async function getTranslations(params = {}) {
  const res = await axios({
    url: [API, "/api-admin/v2/translation"].join(""),
    method: "GET",
    withCredentials: true,
    params: compactParams(params),
  });
  return {
    data: Array.isArray(res.data?.data) ? res.data.data : [],
    message: res.data?.message || "success",
  };
}

export async function createTranslation(payload) {
  const res = await axios({
    url: [API, "/api-admin/v2/translation-create"].join(""),
    method: "POST",
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
    data: payload,
  });
  return res.data;
}

export async function updateTranslation(payload) {
  const res = await axios({
    url: [API, "/api-admin/v2/translation-update"].join(""),
    method: "POST",
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
    data: payload,
  });
  return res.data;
}

export async function deleteTranslation(payload) {
  const res = await axios({
    url: [API, "/api-admin/v2/translation-delete"].join(""),
    method: "POST",
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
    data: payload,
  });
  return res.data;
}
